export default __webpack_public_path__ + "static/media/item_3@3x.bfa07792.png";